import React from "react";
import Summary from "../../../../components/cases/assets/balanceOfAssets/corporateShareholding/Summary";

const CorporateShareholdings = ({ next, back, tabText }) => {
  return (
    <>
      <Summary next={next} back={back} />
      {/* <SuggestionBox
        mainText={tabText}
        tabName="CoShareholdings"
        setVisited={visited}
      /> */}
    </>
  );
};

export default CorporateShareholdings;
